export * from './types';

export * from './api/getDetails';
export * from './api/updateDetails';

export const WRONG_CIF = 1;
export const WRONG_DATA_COUNTRIES = 2;
